export const GET_EDIT_PERMISSION_SUCCESS = 'GET_EDIT_PERMISSION_SUCCESS';
export const GET_SCAN_GROUPS_SUCCESS = 'GET_SCAN_GROUPS_SUCCESS';
export const GET_SCAN_ACCOUNTS_SUCCESS = 'GET_SCAN_ACCOUNTS_SUCCESS';
export const GET_GROUP_INFORMATION_SUCCESS = 'GET_GROUP_INFORMATION_SUCCESS';
export const GET_SCAN_POPULATION_SUCCESS = 'GET_SCAN_POPULATION_SUCCESS';
export const GET_GROUP_SCHEDULING_SUCCESS = 'GET_GROUP_SCHEDULING_SUCCESS';
export const ADD_GROUP_SUCCESS = 'ADD_GROUP_SUCCESS';
export const DELETE_GROUP_SUCCESS = 'DELETE_GROUP_SUCCESS';
// export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';
export const ADD_ACCOUNT_SUCCESS = 'ADD_ACCOUNT_SUCCESS';
export const UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS';
export const UPDATE_ADVANCED_SETTINGS = 'UPDATE_ADVANCED_SETTINGS';
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const UPDATE_ERORR_FIELD = 'UPDATE_ERORR_FIELD';

//scan population
export const DELETE_SCAN_POPULATION_SUCCESS = 'DELETE_SCAN_POPULATION_SUCCESS';
export const ADD_SCAN_POPULATION_SUCCESS = 'ADD_SCAN_POPULATION_SUCCESS';
export const SYNC_AD_SUCCESS = 'SYNC_AD_SUCCESS';

//scan scheduling
export const DELETE_GROUP_SCHEDULE_SUCCESS = 'DELETE_GROUP_SCHEDULE_SUCCESS';
export const UPDATE_GROUP_SCHEDULE_SUCCESS = 'UPDATE_GROUP_SCHEDULE_SUCCESS';
export const ADD_GROUP_SCHEDULE_SUCCESS = 'ADD_GROUP_SCHEDULE_SUCCESS';

//Configuration
export const UPDATE_EXCLUDED_IPS_LIST_SUCCESS = 'UPDATE_EXCLUDED_IPS_LIST_SUCCESS';
export const UPDATE_EXCLUDED_HOST_NAMES_LIST_SUCCESS = 'UPDATE_EXCLUDED_HOST_NAMES_LIST_SUCCESS';
export const GET_TV_MODE_TOKEN = 'GET_TV_MODE_TOKEN';
export const UPDATE_TV_MODE_TOKEN = 'UPDATE_TV_MODE_TOKEN';

//conf - proxyparsers
export const GET_PROXY_PARSERS_SUCCESS = 'GET_PROXY_PARSERS_SUCCESS';
export const UPDATE_PROXY_PARSERS_SUCCESS = 'UPDATE_PROXY_PARSERS_SUCCESS';
export const ADD_PROXY_PARSERS_SUCCESS = 'ADD_PROXY_PARSERS_SUCCESS';
export const DELETE_PROXY_PARSERS_SUCCESS = 'DELETE_PROXY_PARSERS_SUCCESS';
export const VALIDATE_PARSERS_SUCCESS = 'VALIDATE_PARSERS_SUCCESS';

//conf - proxyparsers folders
export const GET_PROXY_FOLDERS_SUCCESS = 'GET_PROXY_FOLDERS_SUCCESS';
export const ADD_PROXY_FOLDER_SUCCESS = 'ADD_PROXY_FOLDER_SUCCESS';
export const DELETE_PROXY_FOLDER_SUCCESS = 'DELETE_PROXY_FOLDER_SUCCESS';
export const EDIT_PROXY_FOLDER_SUCCESS = 'EDIT_PROXY_FOLDER_SUCCESS';

//conf - vpn parsers
export const GET_VPN_PARSERS_SUCCESS = 'GET_VPN_PARSERS_SUCCESS';
export const UPDATE_VPN_PARSERS_SUCCESS = 'UPDATE_VPN_PARSERS_SUCCESS';
export const ADD_VPN_PARSERS_SUCCESS = 'ADD_VPN_PARSERS_SUCCESS';
export const DELETE_VPN_PARSERS_SUCCESS = 'DELETE_VPN_PARSERS_SUCCESS';
export const VALIDATE_VPN_PARSERS_SUCCESS = 'VALIDATE_VPN_PARSERS_SUCCESS';

//conf - vpn parsers folders
export const GET_VPN_FOLDERS_SUCCESS = 'GET_VPN_FOLDERS_SUCCESS';
export const ADD_VPN_FOLDER_SUCCESS = 'ADD_VPN_FOLDER_SUCCESS';
export const DELETE_VPN_FOLDER_SUCCESS = 'DELETE_VPN_FOLDER_SUCCESS';
export const EDIT_VPN_FOLDER_SUCCESS = 'EDIT_VPN_FOLDER_SUCCESS';

//conf - AD and CSV user data
export const ADD_AD_AND_CSV_PARSER_DATA_SUCCESS = 'ADD_AD_AND_CSV_PARSER_DATA_SUCCESS';

//conf - elastic search server configuration
export const GET_ES_CONFIGURATION_SUCCESS = 'GET_ES_CONFIGURATION_SUCCESS';
export const UPDATE_ES_CONFIGURATION_FIELD_SUCCESS = 'UPDATE_ES_CONFIGURATION_FIELD_SUCCESS';

//ADVANCED
export const SET_EXTENSION_VALUE_ADVANCED = 'SET_EXTENSION_VALUE_ADVANCED';
export const SET_CUSTOM_EPS_CERT_ADVANCED = 'SET_CUSTOM_EPS_CERT_ADVANCED';

//users
export const UPDATE_USERS_SUCCESS = 'UPDATE_USERS_SUCCESS';
export const GET_LOGGED_USER_SUCCESS = 'GET_LOGGED_USER_SUCCESS';
export const GET_ALL_SITES = 'GET_ALL_SITES_SUCCESS';
export const GET_USERS_BY_LOGGED_IN_USER_PERMISSIONS = 'GET_USERS_BY_LOGGED_IN_USER_PERMISSIONS_SUCCESS';
export const UPDATE_USER_ROLE_SUCESS = 'UPDATE_USER_ROLE_SUCESS';

export const ADD_SITE_TO_USER = 'ADD_SITE_TO_USER';
export const REMOVE_SITE_TO_USER = 'REMOVE_SITE_TO_USER';
export const TOGGLE_ALL_SITES_INTERACTION_START = 'TOGGLE_ALL_SITES_INTERACTION_START';
export const ADD_ALL_SITES_TO_USER_SUCCESS = 'ADD_ALL_SITES_TO_USER';
export const REMOVE_ALL_SITES_FROM_USER_SUCCESS = 'REMOVE_ALL_SITES_TO_USER';
export const TOGGLE_ALL_SITES_INTERACTION_ERROR = 'TOGGLE_ALL_SITES_INTERACTION_ERROR';
export const DISMISS_SITE_TOGGLING_ERROR = 'DISMISS_SITE_TOGGLING_ERROR';

//clients sites management
export const ADD_SITE = 'ADD_SITE';
export const REMOVE_SITE = 'REMOVE_SITE';
export const GET_ALL_SLAVES_SITES = 'GET_ALL_SLAVES_SITES';
//analysis
export const GET_ANALYSIS_SUCCESS = 'GET_ANALYSIS_SUCCESS';
export const SAVE_ANALYSIS_SUCCESS = 'SAVE_ANALYSIS_SUCCESS';

//alerts
export const GET_ALERTS_SETTINGS_SUCCESS = 'GET_ALERTS_SETTINGS_SUCCESS';
export const SAVE_ALERTS_SETTINGS_SUCCESS = 'SAVE_ALERTS_SETTINGS_SUCCESS';

//system info
export const GET_SYSTEM_INFO_SUCCESS = 'GET_SYSTEM_INFO_SUCCESS';

//maps
export const GET_SETTINGS_MAPS_DATA_SUCCESS = 'GET_SETTINGS_MAPS_DATA_SUCCESS';
export const UPDATE_SETTINGS_MAPS_DATA_ITEM = 'UPDATE_SETTINGS_MAPS_DATA_ITEM';
export const SWITCH_TO_MAP_REGION = 'SWITCH_TO_MAP_REGION';
export const SWITCH_TO_MAP_TABLE = 'SWITCH_TO_MAP_TABLE';
export const SAVE_REGION_DATA = 'SAVE_REGION_DATA';

//Active Directory
export const SET_ACTIVE_DIRECTORY_GROUPS = 'GET_ACTIVE_DIRECTORY_GROUPS';
export const SET_ACTIVE_DIRECTORY_GROUPS_ENABLED = 'SET_ACTIVE_DIRECTORY_GROUPS_ENABLED';
export const REMOVE_ACTIVE_DIRECTORY_GROUPS_ENABLED = 'REMOVE_ACTIVE_DIRECTORY_GROUPS_ENABLED';
export const ADD_ACTIVE_DIRECTORY_GROUPS_ENABLED = 'ADD_ACTIVE_DIRECTORY_GROUPS_ENABLED';
export const GET_ACTIVE_DIRECTORY_CONNECTIONS = 'GET_ACTIVE_DIRECTORY_CONNECTIONS';
export const ADD_ACTIVE_DIRECTORY_CONNECTIONS = 'ADD_ACTIVE_DIRECTORY_CONNECTIONS';
export const SET_ACTIVE_DIRECTORY_CONNECTIONS = 'SET_ACTIVE_DIRECTORY_CONNECTIONS';
export const REMOVE_ACTIVE_DIRECTORY_CONNECTIONS = 'REMOVE_ACTIVE_DIRECTORY_CONNECTIONS';
export const UPDATE_IDENTITY_ROLE_SUCESS = 'UPDATE_IDENTITY_ROLE_SUCESS';

export const SET_AUTHNETICATION_MODE = 'SET_AUTHNETICATION_MODE';

//AWS S3
export const GET_AWS_S3_SETTINGS = 'GET_AWS_S3_SETTINGS';
export const GET_AWS_S3_BUCKET_SETTINGS = 'GET_AWS_S3_BUCKET_SETTINGS';
export const ADD_AWS_S3_SETTINGS = 'ADD_AWS_S3_SETTINGS';
export const ADD_AWS_S3_BUCKET_SETTINGS = 'ADD_AWS_S3_BUCKET_SETTINGS';
export const UPDATE_AWS_S3_SETTINGS = 'UPDATE_AWS_S3_SETTINGS';
export const UPDATE_AWS_S3_BUCKET_SETTINGS = 'UPDATE_AWS_S3_BUCKET_SETTINGS';
export const REMOVE_AWS_S3_SETTINGS = 'REMOVE_AWS_S3_SETTINGS';
export const REMOVE_AWS_S3_BUCKET_SETTINGS = 'REMOVE_AWS_S3_BUCKET_SETTINGS';
export const ADD_AUDITS_AWS_S3_SETTINGS_TO_BUCKET_SETTINGS = 'ADD_AUDITS_AWS_S3_SETTINGS_TO_BUCKET_SETTINGS';
export const ADD_ALERTS_AWS_S3_SETTINGS_TO_BUCKET_SETTINGS = 'ADD_ALERTS_AWS_S3_SETTINGS_TO_BUCKET_SETTINGS';
export const GET_AWS_S3_SETTINGS_TO_BUCKET_SETTINGS = 'GET_AWS_S3_SETTINGST_TO_BUCKET_SETTINGS';
export const REMOVE_AUDITS_AWS_S3_SETTINGS_TO_BUCKET_SETTINGS = 'REMOVE_AUDITS_AWS_S3_SETTINGST_TO_BUCKET_SETTINGS';
export const REMOVE_ALERTS_AWS_S3_SETTINGS_TO_BUCKET_SETTINGS = 'REMOVE_ALERTS_AWS_S3_SETTINGST_TO_BUCKET_SETTINGS';

//vulnerable management
export const VULNERABLE_MANAGEMENT_TAB_SELECT_SUCCESS = 'VULNERABLE_MANAGEMENT_TAB_SELECT_SUCCESS';
export const WINDOWS_CRITICAL_PATCHES_UPDATE_SUCCESS = 'WINDOWS_CRITICAL_PATCHES_UPDATE_SUCCESS';
export const RISKY_APPLICATION_UPDATE_SUCCESS = 'RISKY_APPLICATION_UPDATE_SUCCESS';
export const RUNNING_APPS_UPDATE_SUCCESS = 'RUNNING_APPS_UPDATE_SUCCESS';
export const OUTDATE_APPLICATION_UPDATE_SUCCESS = 'OUTDATE_APPLICATION_UPDATE_SUCCESS';

// Uba events
export const SET_UBA_EVENTS = 'SET_UBA_EVENTS';
export const CREATE_UBA_EVENT = 'CREATE_UBA_EVENT';
export const DELETE_UBA_EVENT = 'DELETE_UBA_EVENT';
export const UPDATE_UBA_EVENT = 'UPDATE_UBA_EVENT';

//THREAT HUNTING
export const SET_THREAT_HUNTING_DATA = 'SET_THREAT_HUNTING_DATA';
export const SET_THREAT_HUNTING_META_DATA = 'SET_THREAT_HUNTING_META_DATA';

//DECOY
export const SAVE_DECOY_DATA = 'SAVE_DECOY_DATA';
export const ADD_CHANGED_DECOY_FILE_OBJECT = 'ADD_CHANGED_DECOY_FILE_OBJECT';
export const SAVE_DECOY_GROUPS_AND_FOLDERS = 'SAVE_DECOY_GROUPS_AND_FOLDERS';
export const UPDATE_DECOY_GROUPS_AND_FOLDERS = 'UPDATE_DECOY_GROUPS_AND_FOLDERS';
export const SAVE_GROUP_WITH_DECOY_ENABLED = 'SAVE_GROUP_WITH_DECOY_ENABLED';

// WINDOWS EVETNS
export const GET_WINDOWS_EVENTS_PROFILES_SUCCESS = 'GET_WINDOWS_EVENTS_PROFILES_SUCCESS';
export const ADD_WINDOWS_EVENTS_PROFILE_SUCCESS = 'ADD_WINDOWS_EVENTS_PROFILE_SUCCESS';
export const UPDATE_WINDOWS_EVENTS_PROFILE_SUCCESS = 'UPDATE_WINDOWS_EVENTS_PROFILE_SUCCESS';
export const REMOVE_WINDOWS_EVENTS_PROFILE_SUCCESS = 'REMOVE_WINDOWS_EVENTS_PROFILE_SUCCESS';

// STORAGE DEVICES
export const GET_STORAGE_DEVICES_PROFILES_SUCCESS = 'GET_STORAGE_DEVICES_PROFILES_SUCCESS';
export const ADD_STORAGE_DEVICES_PROFILE_SUCCESS = 'ADD_STORAGE_DEVICES_PROFILE_SUCCESS';
export const UPDATE_STORAGE_DEVICES_PROFILE_SUCCESS = 'UPDATE_STORAGE_DEVICES_PROFILE_SUCCESS';
export const STORAGE_DEVICES_PROFILE_ERROR = 'STORAGE_DEVICES_PROFILE_ERROR';
export const REMOVE_STORAGE_DEVICES_PROFILE_SUCCESS = 'REMOVE_STORAGE_DEVICES_PROFILE_SUCCESS';
export const GET_STORAGE_DEVICES_VENDORS_AND_PRODUCTS_SUCCESS = 'GET_STORAGE_DEVICES_VENDORS_AND_PRODUCTS_SUCCESS';

//QUICK STORAGE DEVICE EXCEPTION
export const GET_STORAGE_DEVICES_PROFILES_WITH_UNAUTHORIZED_CLASSIFICATION_SUCCESS =
  'GET_STORAGE_DEVICES_PROFILES_WITH_UNAUTHORIZED_CLASSIFICATION_SUCCESS';
export const GET_STORAGE_DEVICE_ID_FROM_ALERT_SUCCESS = 'GET_STORAGE_DEVICE_ID_FROM_ALERT_SUCCESS';
export const ADD_EXCEPTION_TO_STORAGE_DEVICE_PROFILES_SUCCESS = 'ADD_EXCEPTION_TO_STORAGE_DEVICE_PROFILES_SUCCESS';

//WHITELISTING
export const SET_WHITELISTING_DATA = 'SET_WHITELISTING_DATA';
export const SET_WHITELISTING_RULES_ALERTS = 'SET_WHITELISTING_RULES_ALERTS';
export const SET_WHITELISTING_RULES_TYPES = 'SET_WHITELISTING_RULES_TYPES';
export const GET_SITES_WHITELISTING_PROFILES_SUCCESS = 'GET_SITES_WHITELISTING_PROFILES_SUCCESS';
export const GET_SITES_EXCLUSION_PROFILES_SUCCESS = 'GET_SITES_EXCLUSION_PROFILES_SUCCESS';

export const GET_WHITELISTING_RULES_PROFILES_SUCCESS = 'GET_WHITELISTING_RULES_PROFILES_SUCCESS';
export const GET_WHITELISTING_EXCLUSION_RULES_PROFILES_SUCCESS = 'GET_WHITELISTING_EXCLUSION_RULES_PROFILES_SUCCESS';

export const GET_QUICK_WHITELISTING_PROFILE_REQUEST = 'GET_QUICK_WHITELISTING_PROFILE_REQUEST';
export const GET_QUICK_WHITELISTING_PROFILE_SUCCESS = 'GET_QUICK_WHITELISTING_PROFILE_SUCCESS';
export const GET_QUICK_WHITELISTING_PROFILE_ERROR = 'GET_QUICK_WHITELISTING_PROFILE_ERROR';

export const ADD_QUICK_WHITELISTING_RULES_PROFILE_REQUEST = 'ADD_QUICK_WHITELISTING_RULES_PROFILE_REQUEST';
export const ADD_QUICK_WHITELISTING_RULES_PROFILE_SUCCESS = 'ADD_QUICK_WHITELISTING_RULES_PROFILE_SUCCESS';
export const ADD_QUICK_WHITELISTING_RULES_PROFILE_ERROR = 'ADD_QUICK_WHITELISTING_RULES_PROFILE_ERROR';

export const GET_WHITELISTING_RULES_PROFILE_FOR_EDIT_SUCCESS = 'GET_WHITELISTING_RULES_PROFILE_FOR_EDIT_SUCCESS';
export const GET_WHITELISTING_RULES_PROFILE_FOR_EDIT_FAILURE = 'GET_WHITELISTING_RULES_PROFILE_FOR_EDIT_FAILURE';

export const GET_EXCLUSION_RULES_PROFILE_FOR_EDIT_SUCCESS = 'GET_EXCLUSION_RULES_PROFILE_FOR_EDIT_SUCCESS';
export const GET_EXCLUSION_RULES_PROFILE_FOR_EDIT_FAILURE = 'GET_EXCLUSION_RULES_PROFILE_FOR_EDIT_FAILURE';

export const ADD_WHITELISTING_RULES_PROFILE_SUCCESS = 'ADD_WHITELISTING_RULES_PROFILE_SUCCESS';
export const ADD_WHITELISTING_RULES_PROFILE_ERROR = 'ADD_WHITELISTING_RULES_PROFILE_ERROR';

export const UPDATE_WHITELISTING_RULES_PROFILE_SUCCESS = 'UPDATE_WHITELISTING_RULES_PROFILE_SUCCESS';

export const REMOVE_WHITELISTING_RULES_PROFILE_SUCCESS = 'REMOVE_WHITELISTING_RULES_PROFILE_SUCCESS';

export const GET_WHITELISTING_RULES_SCAN_GROUPS_SUCCESS = 'GET_WHITELISTING_RULES_SCAN_GROUPS_SUCCESS';

export const GET_WHITELISTING_RULES_HOSTS_REQUEST = 'GET_WHITELISTING_RULES_HOSTS_REQUEST';
export const GET_WHITELISTING_RULES_HOSTS_SUCCESS = 'GET_WHITELISTING_RULES_HOSTS_SUCCESS';

export const SAVE_WHITELISTING_RULES_PROFILE = 'SAVE_WHITELISTING_RULES_PROFILE';

//Global Settings
export const GET_GLOBAL_SETTINGS_SUCCESS = 'GET_GLOBAL_SETTINGS_SUCCESS';

//Protection Features
export const GET_PROTECTION_PROFILES_SUCCESS = 'GET_PROTECTION_PROFILES_SUCCESS';

/* Remediations */
export const SET_CUSTOM_REMEDIATION_IS_LOADING_DATA = 'SET_CUSTOM_REMEDIATION_IS_LOADING_DATA';
export const SET_SELECTED_REMEDIATION_TAB = 'SET_SELECTED_REMEDIATION_TAB';

//CUSTOM REMEDIATION
export const SET_CUSTOM_REMEDIATION_VIEW_STATE = 'SET_CUSTOM_REMEDIATION_VIEW_STATE';
export const SET_CURRENT_EDITED_CUSTOM_REMEDIATION = 'SET_CURRENT_EDITED_CUSTOM_REMEDIATION';
export const UPDATE_CUSTOM_REMEDIATIONS = 'UPDATE_CUSTOM_REMEDIATIONS';
export const GET_ACTIVE_VAULT_OBJECTS = 'GET_ACTIVE_VAULT_OBJECTS';

// deception users configuration
export const GET_ALL_DECEPTION_USER_CONFIGURATION = 'GET_ALL_DECEPTION_USER_CONFIGURATION';
export const GET_DECEPTION_USERS_TO_DENY = 'GET_DECEPTION_USERS_TO_DENY';

//PLAYBOOKS
export const SET_PLAYBOOKS_VIEW_STATE = 'SET_PLAYBOOKS_VIEW_STATE';
export const SET_PLAY_BOOK_FORM_DATA = 'SET_PLAY_BOOK_FORM_DATA';
export const UPDATE_PLAYBOOKS = 'UPDATE_PLAYBOOKS';

//CUSTOM REMEDIATION EXECUTION SERVERS
export const UPDATE_CUSTOM_REMEDIATION_EXECUTION_SERVERS = 'UPDATE_CUSTOM_REMEDIATION_EXECUTION_SERVERS';
export const UPDATE_CUSTOM_REMEDIATION_HAS_AVAILABLE_EXECUTION_SERVERS =
  'UPDATE_CUSTOM_REMEDIATION_HAS_AVAILABLE_EXECUTION_SERVERS';

//SYSLOG SETTINGS
export const GET_ALL_SYSLOG_SETTINGS = 'GET_ALL_SYSLOG_SETTINGS';
export const ADD_SYSLOG_SETTINGS = 'ADD_SYSLOG_SETTINGS';
export const DELETE_SYSLOG_SETTINGS = 'DELETE_SYSLOG_SETTINGS';

// deception
export const SET_SELECTED_DECEPTION_TAB = 'SET_SELECTED_DECEPTION_TAB';

// deception network configuration
export const SET_DECEPTION_NETWORK_CONFIGURATION = 'SET_DECEPTION_NETWORK_CONFIGURATION';
export const SET_DECEPTION_NETWORK_SELECTED_GROUP_ID = 'SET_DECEPTION_NETWORK_SELECTED_GROUP_ID';
export const SET_DECEPTION_NETWORK_MAX_DECOY_HOSTS = 'SET_DECEPTION_NETWORK_MAX_DECOY_HOSTS';
export const SET_DECEPTION_NETWORK_MULTI_SELECT = 'SET_DECEPTION_NETWORK_MULTI_SELECT';
export const SET_DECEPTION_NETWORK_OS_VERSIONS = 'SET_DECEPTION_NETWORK_OS_VERSIONS';

//CISO KIT
export const GET_ALL_CISO_KIT_CONNECTIONS = 'GET_ALL_CISO_KIT_CONNECTIONS';
export const ADD_CISO_KIT_CONNECTION = 'ADD_CISO_KIT_CONNECTION';
export const UPDATE_CISO_KIT_CONNECTION = 'UPDATE_CISO_KIT_CONNECTION';
export const DELETE_CISO_KIT_CONNECTION = 'DELETE_CISO_KIT_CONNECTION';
export const IS_CISO_KIT_ENABLED = 'IS_CISO_KIT_ENABLED';

//PROXY
export const GET_ALL_WEB_PROXY_SETTINGS = 'GET_ALL_WEB_PROXY_SETTINGS';
export const CREATE_WEB_PROXY = 'CREATE_WEB_PROXY';
export const UPDATE_WEB_PROXY = 'UPDATE_WEB_PROXY';
export const DELETE_WEB_PROXY = 'DELETE_WEB_PROXY';

export const GET_ES_STATUS = 'GET_ES_STATUS';

//file monitor
export const GET_FILE_MONITOR_RULES_PROFILES_SUCCESS = 'GET_FILE_MONITOR_RULES_PROFILES_SUCCESS';
export const GET_FILE_MONITOR_PROFILE_FOR_EDIT_SUCCESS = 'GET_FILE_MONITOR_PROFILE_FOR_EDIT_SUCCESS';

export const ADD_FILE_MONITOR_PROFILE_SUCCESS = 'ADD_FILE_MONITOR_PROFILE_SUCCESS';
export const REMOVE_FILE_MONITOR_PROFILE_SUCCESS = 'REMOVE_FILE_MONITOR_PROFILE_SUCCESS';
export const UPDATE_FILE_MONITOR_PROFILE_SUCCESS = 'UPDATE_FILE_MONITOR_PROFILE_SUCCESS';

//--------global
export const GET_TAGS = 'GET_TAGS';
export const GET_CLIENT_TYPES = 'GET_CLIENT_TYPES';
export const SET_GLOBAL_VERSION = 'SET_GLOBAL_VERSION';
export const SET_SITE_BILLING = 'SET_SITE_BILLING';

//SIEM
export const UPDATE_SLAVE_SITE_SETTINGS = 'UPDATE_SLAVE_SITE_SETTINGS';
export const UPDATE_SIEM_ERROR_FIELD = 'UPDATE_SIEM_ERROR_FIELD';
export const UPDATE_SIEM_STATUSES = 'UPDATE_SIEM_STATUSES';
export const UPDATE_SIEM_ALL_SETTINGS = 'UPDATE_SIEM_ALL_SETTINGS';
export const UPDATE_SIEM_GLOBAL_SETTINGS = 'UPDATE_SIEM_GLOBAL_SETTINGS';

export const INITIALIZE_SITES_CONFIG_DATA = 'INITIALIZE_SITES_CONFIG_DATA';

//groups
export const INITIALIZE_SCAN_GROUPS_TAB_DATA = 'INITIALIZE_SCAN_GROUPS_TAB_DATA';
export const UPDATE_SCAN_GROUPS_FEATURES = 'UPDATE_SCAN_GROUPS_FEATURES';
export const UPDATE_SITES_SCAN_GROUPS = 'UPDATE_SITES_SCAN_GROUPS';
export const UPDATE_SCAN_GROUPS_SELECTED_FEATURE = 'UPDATE_SCAN_GROUPS_SELECTED_FEATURE';

export const UPDATE_SCAN_GROUPS_SLAVE_SITES_STATUS = 'UPDATE_SCAN_GROUPS_SLAVE_SITES_STATUS';
export const INITIALIZE_SCAN_GROUPS_FEATURES_FORM_STATUS = 'INITIALIZE_SCAN_GROUPS_FEATURES_FORM_STATUS';

export const UPDATE_SCAN_GROUPS_MULTIPLE_EDIT_FORM = 'UPDATE_SCAN_GROUPS_MULTIPLE_EDIT_FORM';

//SITE CONFIG
export const UPDATE_SITES_CONFIG = 'UPDATE_SITES_CONFIG';
export const UPDATE_CONFIG_MULTIPLE_EDIT_FORM = 'UPDATE_CONFIG_MULTIPLE_EDIT_FORM';

export const GET_ALL_SLAVES_SYSTEM_STATUS = 'GET_ALL_SLAVES_SYSTEM_STATUS';
export const SHOULD_SHOW_EDIT_DETAILS = 'SHOULD_SHOW_EDIT_DETAILS';

// Email Recipients
export const UPDATE_SITES_EMAIL_RECIPIENTS = 'UPDATE_SITES_EMAIL_RECIPIENTS';
export const UPDATE_EMAIL_RECIPIENTS_MULTIPLE_EDIT_FORM = 'UPDATE_EMAIL_RECIPIENTS_MULTIPLE_EDIT_FORM';
//--------end global ------------------

// advanced reports schedules list
export const GET_ADVANCED_REPORTS_SCHEDULES_LIST = 'GET_ADVANCED_REPORTS_SCHEDULES_LIST';

export const GET_USER_HAS_PERMISSION_ALL_MSSP_SITES = 'GET_USER_HAS_PERMISSION_ALL_MSSP_SITES';
